/**
 * How Sun's context verdict is coloured. Not a style token but a rule about meaning, which is why it
 * stays with the widget while the type system it is used next to lives in generic/qr/qrReadingStyles.
 */

/**
 * The palette key that carries the verdict: mint for an element that belongs to the work running at
 * this station, amber for one that does not.
 *
 * The same pair colours the dialog title and its warning, so the verdict is one colour throughout —
 * an operator who learns it on the widget reads it again in the card without being told.
 */
export const verdictColor = (isForeign = false) => isForeign ? 'warning' : 'primary'
